/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { amountComparator } from '../../../../SharedModules/utilities/utilities';
export const tablehead = [
  {
    headerName: 'Action',
    field: 'action',
    filter: false,
    sortable: true,
    enableMenu: false,
    minWidth: Styles.Width_70 + Styles.Length_10,
    maxWidth: Styles.Width_70 + Styles.Length_10,
    resizable: true,
    editable: false,
    suppressMenu: false,
    // pinned: 'left',
    // lockPinned: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sort: 'asc',
    sortable: true,
    // pinned: 'left',
    // lockPinned: true,
    minWidth: Styles.Width_180 - Styles.Length_5,
    maxWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_380,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'MfgNameCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Send?',
    field: 'sendFlag',
    showCheckboxIcon: true,
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    suppressMenu: false,
    minWidth:75,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action frr-generate-checkbox',
    cellRenderer: 'CheckBoxCellRender1',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    fillBackgroundColorCol: 'sendClrId',
    showBackgroundColor: true,
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.sendClrId?.toString() === '16756655',
      'yellow-legend': (params) =>
        params.data?.sendClrId?.toString() === '11534335',
      'pink-legend': (params) =>
        params.data?.sendClrId?.toString() === '11513855',
      'white-legend': (params) =>
        params.data?.sendClrId?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.sendClrId?.toString() === '12632256',
    },
  },
  {
    headerName: 'Not Needed',
    field: 'notNeededFlag',
    showCheckboxIcon: true,
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action frr-generate-checkbox',
    cellRenderer: 'CheckBoxCellRender2',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Customized?',
    field: 'ccCustomized',
    showCheckboxIcon: true,
    hideFilterIcon: true,
    editable: false,
    sortable: true,
    filter: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    suppressMenu: false,
    minWidth: 115,
    maxWidth: 115,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action frr-generate-checkbox',
    cellRenderer: 'CheckBoxCellRender3',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Percent Paid',
    field: 'percentPaid',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    printPostfixValue: '%',
    minWidth: Styles.Width_150,
    cellRenderer: 'percentPaidCell',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amt Owned',
    cellRenderer: 'invoiceCorrectionAmtCellRender1',
    field: 'amountOwed',
    comparator:amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    printPrefixValue: '$',
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amt Paid To Date',
    cellRenderer: 'invoiceCorrectionAmtCellRender3',
    field: 'amountPaidDate',
    comparator:amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    printPrefixValue: '$',
    minWidth: Styles.Width_200 + Styles.Length_5,
    maxWidth: Styles.Width_200 + Styles.Length_5,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Rebate Amt',
    cellRenderer: 'invoiceCorrectionAmtCellRender2',
    field: 'currRebateAmount',
    comparator:amountComparator,
    editable: false,
    isTextColorRed: true,
    printPrefixValue: '$',
    sortable: true,
    minWidth: Styles.Width_220,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Days Since Distribution',
    field: 'dayCount',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    printPrefixValue: '',
    minWidth: Styles.Width_210 + Styles.Length_5,
    maxWidth: Styles.Width_210 + Styles.Length_5,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Letter Sent Date',
    field: 'sentDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Invoice Amt',
    cellRenderer: 'invoiceCorrectionAmtCellRender4',
    field: 'invAmount',
    comparator:amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    printPrefixValue: '$',
    minWidth: Styles.Width_220 + Styles.Length_3,
    maxWidth: Styles.Width_220 + Styles.Length_3,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contact Email Address',
    field: 'emailAdd',
    editable: false,
    sortable: true,
    resizable: false,
    columnSpan: 2,
    minWidth: Styles.Width_210 + Styles.Length_5,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'MailCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isBgColor: true,
    bgColorName: 'emailClrId',
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.sendClrId?.toString() === '16756655',
      'yellow-legend': (params) => params.data?.emailAdd === '',
      // 'pink-legend': (params) => params.data?.sentDt,
      'white-legend': (params) =>
        params.data?.sendClrId?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.sendClrId?.toString() === '12632256',
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
export default tablehead;
